export default __webpack_public_path__ + "static/media/Attach02.6317a5c2.svg";